import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const company = async (id?: number) => axios.get(Routes.COMPANY + "/" + id);

export const useCompany = (id?: number) =>
  useQuery({
    queryKey: [Keys.COMPANY_QRY, id],
    queryFn: () => company(id),
    enabled: id ? true : false,
  });
